module.exports = __webpack_public_path__ + "img/pugongying.9a5d69dc.png";